import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
class VerifyStatusGuardService {
  readonly router: Router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot) {
    const status = route.paramMap.get('status');
    const allowedStatuses = ['success', 'expired', 'invalid'];

    if (status && allowedStatuses.includes(status)) {
      return true;
    }

    return this.router.parseUrl('/');
  }
}

export const VerifyStatusGuard: CanActivateFn = (route) => inject(VerifyStatusGuardService).canActivate(route);
